<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>{{ 'Standortdetails' | translate }}</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <div *ngIf="patientDataProvider.activePatientData.addressData.firstname">
        <ion-row>
            <ion-col border-right size="12" sizeLg="6">
                <adress-detail [address]="patientDataProvider.activePatientData.addressData"></adress-detail>
            </ion-col>
            <ion-col size="12"  sizeLg="6">
                <management-details [management]="patientDataProvider.activePatientData.management"
                                    [transmitterId]="patientDataProvider.activePatientData.transmitterId"></management-details>
            </ion-col>
            <ion-col size="12">
                <app-phone-data (selectedRow)="phoneDataSelect($event)"
                            [addressData]="patientDataProvider.activePatientData.addressData"
                            [phoneData]="patientDataProvider.activePatientData.contactNumbers || []"></app-phone-data>
            </ion-col>
        </ion-row>
    </div>
</div>
